import { TextField } from '@pankod/refine-antd';
import { IResourceComponentsProps } from '@pankod/refine-core';
import { getReleasePurchaseById } from 'apis/release';
import { useCallback, useEffect, useState } from 'react';
import 'react-mde/lib/styles/css/react-mde-all.css';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { formatDateTime } from 'utils';

export const ReleasePurchaseShow: React.FC<IResourceComponentsProps> = () => {
    const { id } = useParams();
    const [releasePurchases, setReleasePurchases] = useState<any>();
    const handleGetReleasePurchaseById = useCallback(async (id) => {
        const res = await getReleasePurchaseById(id);
        setReleasePurchases(res?.data);
    }, []);

    useEffect(() => {
        if (id) {
            handleGetReleasePurchaseById(id);
        }
    }, [handleGetReleasePurchaseById, id]);

    return (
        <div style={{ marginTop: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: '35px' }}>
                <p style={{ width: '40%', fontWeight: 500, color: '#000', textAlign: 'center' }}>Buyer</p>
                <p style={{ width: '40%', fontWeight: 500, color: '#000', textAlign: 'center' }}>Date</p>
                <p style={{ width: '20%', fontWeight: 500, color: '#000', textAlign: 'center' }}>Order</p>
            </div>
            {(releasePurchases || []).map((item: any, index: any) => {
                return (
                    <div key={index} style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <p style={{ width: '40%', textAlign: 'center' }}>{item?.user[0].username}</p>
                        <p style={{ width: '40%', textAlign: 'center' }}>{formatDateTime(item?.createdAt)}</p>
                        <p style={{ width: '20%', textAlign: 'center' }}>
                            <Link to={`/orders/show/${item?.orders[0]._id}`}>
                                <TextField style={{ color: 'blue' }} value={item?.orders[0].orderId} />
                            </Link>
                        </p>
                    </div>
                );
            })}
        </div>
    );
};
